import React, { useState, useMemo } from 'react'
import { t, Trans } from '@lingui/macro'

import { Modal } from '../../../components/common/modal/Modal'
import { ButtonClean, ButtonPrimary } from 'front-end/src/components'
import Input from '../../../components/common/form/input/Input'
import Form, { FormRow } from '../../../components/common/form/Form'
import Label from '../../../components/common/form/label/Label'
import uniqueId from '../../../components/utils/uniqueId'

import { useCreateThemeModalMutation } from './CreateThemeModal.codegen'

type Props = {
  workspaceId: number
  resolve: () => void
  reject: () => void
}

export const CreateThemeModal: React.FC<Props> = (props) => {
  const { reject, resolve } = props

  const [title, setTitle] = useState('')

  const [createThemeModal, { loading }] = useCreateThemeModalMutation()
  const inputTitleId = useMemo(uniqueId, [])

  const create = async () => {
    const res = await createThemeModal({
      variables: {
        workspaceId: props.workspaceId,
        title
      }
    })

    if (!res.errors) {
      setTitle('')
      resolve()
    }
  }

  return (
    <Modal
      onHide={reject}
      header={t`Create a new theme`}
      controls={
        <>
          <ButtonClean onClick={reject}>
            <Trans>Cancel</Trans>
          </ButtonClean>
          <ButtonPrimary disabled={!title} onClick={create} isLoading={loading}>
            <Trans>Create</Trans>
          </ButtonPrimary>
        </>
      }
    >
      <Form onSubmit={create}>
        <FormRow>
          <Label htmlFor={inputTitleId}>
            <Trans>Title</Trans>
          </Label>
          <Input
            autoFocus
            value={title}
            onChange={(val) => setTitle(val)}
            id={inputTitleId}
            fullWidth
            placeholder={t`First week training`}
          />
        </FormRow>
      </Form>
    </Modal>
  )
}
